(function(){
var $=function(i){return document.getElementById(i)};
var dr=$("drawer"),mb=$("menu");
var hamburgerSVG=mb.innerHTML;
var closeSVG='<svg width="26" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M4 4l16 16M20 4L4 20"/></svg>';
function menu(o){dr.classList.toggle("open",o);mb.setAttribute("aria-expanded",o);mb.innerHTML=o?closeSVG:hamburgerSVG;
  document.body.style.overflow=o?"hidden":"";
  if(o)$("close").focus();else mb.focus()}
mb.addEventListener("click",function(){menu(!dr.classList.contains("open"))});
$("close").addEventListener("click",function(){menu(false)});
dr.querySelectorAll(".drawer-links a").forEach(function(a){a.addEventListener("click",function(){menu(false)})});
document.addEventListener("keydown",function(e){if(e.key==="Escape"&&dr.classList.contains("open"))menu(false)});
var so=$("sort");if(so)so.addEventListener("change",function(){location.href=(so.dataset.base||"/collections/all")+"?sort_by="+so.value});
var hero=$("hero");
if(hero){
 var S=[
  {l:"Get connected to qualified orthotists and prosthetists.",h:"Built around your body",s:"Book a consultation for a prosthesis or orthosis, then shop braces, spinal supports and running gear.",a:"Specialist pointing at a spine x-ray"},
  {l:"Lumbar, knee, ankle and posture supports.",h:"Braces and spinal support",s:"Choose a support, or book a fitting first.",a:"Athlete training with a knee brace"},
  {l:"Compression, insoles and gear for sport.",h:"Run. Train. Recover.",s:"Products picked for active people and athletes.",a:"Runner on a track"}];
 var si=0,dots=document.querySelectorAll(".car .dot"),hp=$("hp"),timer=null;
 function slide(i){si=(i+S.length)%S.length;
  $("hl").textContent=S[si].l;$("hh").textContent=S[si].h;$("hs").textContent=S[si].s;
  hp.style.backgroundImage="url("+hero.dataset["i"+(si+1)]+")";hp.setAttribute("aria-label",S[si].a);
  dots.forEach(function(d,k){d.setAttribute("aria-current",k===si?"true":"false")})}
 function play(){stop();timer=setInterval(function(){slide(si+1)},5000)}
 function stop(){if(timer){clearInterval(timer);timer=null}}
 dots.forEach(function(d,k){d.addEventListener("click",function(){slide(k);play()})});
 $("prev").addEventListener("click",function(){slide(si-1);play()});
 $("next").addEventListener("click",function(){slide(si+1);play()});
 var sx=null,sdx=0;
 hero.addEventListener("touchstart",function(e){sx=e.touches[0].clientX;sdx=0;stop()},{passive:true});
 hero.addEventListener("touchmove",function(e){if(sx!==null)sdx=e.touches[0].clientX-sx},{passive:true});
 hero.addEventListener("touchend",function(){if(Math.abs(sdx)>40){slide(sdx<0?si+1:si-1)}sx=null;play()});
 hero.addEventListener("mouseenter",stop);
 hero.addEventListener("mouseleave",play);
 hero.addEventListener("pointerdown",function(e){if(e.pointerType==="touch")return;sx=e.clientX;sdx=0});
 hero.addEventListener("pointerup",function(e){if(e.pointerType==="touch"||sx===null)return;sdx=e.clientX-sx;if(Math.abs(sdx)>40)slide(sdx<0?si+1:si-1);sx=null});
 document.addEventListener("visibilitychange",function(){if(document.hidden)stop();else play()});
 if(!window.matchMedia("(prefers-reduced-motion: reduce)").matches){slide(0);play()}else{slide(0)}
}
})();
document.querySelectorAll(".pgal").forEach(function(g){
  var main=g.querySelector(".pmain img");
  g.querySelectorAll(".thumbs img").forEach(function(t){
    t.addEventListener("click",function(){
      if(main)main.src=t.src;
      g.querySelectorAll(".thumbs img").forEach(function(o){o.classList.remove("on")});
      t.classList.add("on");
    });
  });
});
document.querySelectorAll(".pqty").forEach(function(q){
  var inp=q.querySelector("input");
  q.querySelector(".minus").addEventListener("click",function(){inp.value=Math.max(1,(parseInt(inp.value)||1)-1)});
  q.querySelector(".plus").addEventListener("click",function(){inp.value=(parseInt(inp.value)||1)+1});
});

(function(){
  var slides=document.querySelectorAll(".rslide");
  if(!slides.length)return;
  var dots=document.querySelectorAll("#rdots .rdot"),ri=0;
  function show(i){ri=(i+slides.length)%slides.length;
    slides.forEach(function(s,k){s.classList.toggle("on",k===ri)});
    dots.forEach(function(d,k){d.setAttribute("aria-current",k===ri?"true":"false")});
  }
  dots.forEach(function(d,k){d.addEventListener("click",function(){show(k)})});
  document.getElementById("rprev").addEventListener("click",function(){show(ri-1)});
  document.getElementById("rnext").addEventListener("click",function(){show(ri+1)});
})();

document.querySelectorAll(".cremove").forEach(function(btn){
  btn.addEventListener("click", function(){
    var row = this.closest(".crow");
    var qty = row && row.querySelector('input[type="number"]');
    if(qty) qty.value = 0;
  });
});
